"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDashboardTab = void 0;
const AdminDashboardTab_1 = require("@frontend/views/AdminDashboardTab");
const CustomTableSupport_1 = require("./CustomTableSupport");
const AdminStudentsTab_1 = require("@frontend/views/AdminStudentsTab");
const Log_1 = __importDefault(require("@common/Log"));
class CustomDashboardTab extends AdminDashboardTab_1.AdminDashboardTab {
    constructor() {
        super(...arguments);
        this.peopleById = new Map();
        this.iconColumn = -1;
        this.subjectColumn = -1;
        this.scoreColumn = -1;
        this.testsColumn = -1;
    }
    init(opts) {
        const _super = Object.create(null, {
            init: { get: () => super.init }
        });
        return __awaiter(this, void 0, void 0, function* () {
            yield this.loadPeople();
            return _super.init.call(this, opts);
        });
    }
    loadPeople() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const people = yield AdminStudentsTab_1.AdminStudentsTab.getPeopleForView(this.remote, "all");
                this.peopleById = new Map();
                for (const person of people !== null && people !== void 0 ? people : []) {
                    if (typeof (person === null || person === void 0 ? void 0 : person.id) === "string" && typeof (person === null || person === void 0 ? void 0 : person.githubId) === "string") {
                        this.peopleById.set(person.id, person);
                    }
                }
                Log_1.default.info("CustomDashboardTab::loadPeople() - people: " + this.peopleById.size);
            }
            catch (err) {
                Log_1.default.error("CustomDashboardTab::loadPeople() - ERROR: " + err.message);
                this.peopleById = new Map();
            }
        });
    }
    buildRepoOptions() {
        const label = document.querySelector("#dashboardRepoLabel");
        if (label !== null) {
            label.textContent = "GitHub Id:";
        }
        const cwls = [];
        for (const cwl of Array.from(this.peopleById.values()).map((person) => person.githubId)) {
            if (cwls.indexOf(cwl) === -1) {
                cwls.push(cwl);
            }
        }
        return cwls.sort();
    }
    personFilter() {
        const select = document.querySelector("#dashboardRepoSelect");
        if (select === null) {
            return null;
        }
        const value = select.value;
        if (typeof value !== "string" || value.length === 0 || value === "-Any-" || value === "any") {
            return null;
        }
        return value;
    }
    buildHeaders() {
        const headers = super.buildHeaders();
        for (const header of headers) {
            if (header.id === "repoId") {
                header.text = "GitHub Id";
            }
            if (header.id === "coverScore") {
                header.text = "Mutation %";
            }
            if (header.id === "?") {
                header.text = "";
            }
        }
        const coverIndex = CustomTableSupport_1.CustomTableSupport.columnOf(headers, "coverScore");
        const testsIndex = coverIndex >= 0 ? coverIndex + 1 : headers.length;
        headers.splice(testsIndex, 0, {
            id: "studentTests",
            text: "# Tests",
            tooltip: "# of student-written tests",
            sortable: true,
            defaultSort: false,
            sortDown: true,
            style: "padding-left: 1em; padding-right: 1em; text-align: center;",
        });
        this.iconColumn = CustomTableSupport_1.CustomTableSupport.columnOf(headers, "?");
        this.subjectColumn = CustomTableSupport_1.CustomTableSupport.columnOf(headers, "repoId");
        this.scoreColumn = CustomTableSupport_1.CustomTableSupport.columnOf(headers, "score");
        this.testsColumn = CustomTableSupport_1.CustomTableSupport.columnOf(headers, "studentTests");
        return headers;
    }
    adminLink(url) {
        return CustomTableSupport_1.CustomTableSupport.toInstructorPrairieLearnUrl(url);
    }
    decorateRow(row, result) {
        var _a, _b;
        if (this.iconColumn >= 0) {
            row[this.iconColumn] = { value: "", html: "" };
        }
        if (this.subjectColumn >= 0) {
            row[this.subjectColumn] = CustomTableSupport_1.CustomTableSupport.githubIdCell(Array.isArray(result === null || result === void 0 ? void 0 : result.people) ? result.people : [], this.peopleById);
        }
        if (this.scoreColumn >= 0) {
            row[this.scoreColumn] = CustomTableSupport_1.CustomTableSupport.withBucketTooltip(row[this.scoreColumn], (_a = result === null || result === void 0 ? void 0 : result.custom) === null || _a === void 0 ? void 0 : _a.bucket);
        }
        const passing = (_b = result === null || result === void 0 ? void 0 : result.custom) === null || _b === void 0 ? void 0 : _b.studentTestsPassing;
        const testsCell = {
            value: typeof passing === "number" ? passing : null,
            html: typeof passing === "number" ? String(passing) : "N/A",
        };
        if (this.testsColumn >= 0) {
            row.splice(this.testsColumn, 0, testsCell);
        }
        else {
            row.push(testsCell);
        }
        return row;
    }
}
exports.CustomDashboardTab = CustomDashboardTab;
